// import React, {
//     forwardRef,
//     useImperativeHandle,
//     useEffect,
//     useCallback,
//     useRef,
//     useState,
//   } from "react";
//   import { useEditor, EditorContent, useEditorState } from "@tiptap/react";
//   import { StarterKit } from "@tiptap/starter-kit";
//   import { Image } from "@tiptap/extension-image";
//   import { Link } from "@tiptap/extension-link";
//   import { TextAlign } from "@tiptap/extension-text-align";
//   import { Underline } from "@tiptap/extension-underline";
//   import { Color, TextStyle } from "@tiptap/extension-text-style";
//   import {
//     Table,
//     TableRow,
//     TableCell,
//     TableHeader,
//   } from "@tiptap/extension-table";
//   import { Placeholder } from "@tiptap/extension-placeholder";
//   import {
//     Undo2,
//     Redo2,
//     Bold,
//     Italic,
//     Underline as UnderlineIcon,
//     Strikethrough,
//     AlignLeft,
//     AlignCenter,
//     AlignRight,
//     List,
//     ListOrdered,
//     Quote,
//     Code,
//     Link as LinkIcon,
//     Image as ImageIcon,
//     Table as TableIcon,
//     Eraser,
//     Columns3,
//     Rows3,
//     Trash2,
//     Plus,
//     Minus,
//   } from "lucide-react";
  
//   /* ──────────────────────────────────────────────────────────────────
//      Toolbar
//      ────────────────────────────────────────────────────────────────── */
  
//   const ToolbarButton = ({ onClick, active, disabled, title, children }) => (
//     <button
//       type="button"
//       onClick={onClick}
//       disabled={disabled}
//       title={title}
//       aria-label={title}
//       aria-pressed={active}
//       className={`inline-flex shrink-0 items-center justify-center w-8 h-8 rounded-md transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${
//         active
//           ? "bg-[#C95EBE] text-white shadow-sm"
//           : "text-gray-600 hover:bg-purple-50 hover:text-[#C95EBE]"
//       }`}
//     >
//       {children}
//     </button>
//   );
  
//   const Divider = () => <div className="w-px h-5 bg-gray-200 mx-1 shrink-0" />;
  
//   const ICON_SIZE = 16;
  
//   const Toolbar = ({ editor, onImageUpload }) => {
//     const scrollRef = useRef(null);
//     const [hasOverflow, setHasOverflow] = useState(false);
  
//     // Detect whether the toolbar overflows so we can show a fade hint on the right edge.
//     useEffect(() => {
//       const el = scrollRef.current;
//       if (!el) return undefined;
  
//       const checkOverflow = () => {
//         const overflowing = el.scrollWidth > el.clientWidth;
//         const scrolledToEnd =
//           el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
//         setHasOverflow(overflowing && !scrolledToEnd);
//       };
  
//       checkOverflow();
  
//       // Re-check when the editor toolbar grows/shrinks (e.g. table buttons appear)
//       const ro = new ResizeObserver(checkOverflow);
//       ro.observe(el);
  
//       el.addEventListener("scroll", checkOverflow, { passive: true });
//       window.addEventListener("resize", checkOverflow);
  
//       return () => {
//         ro.disconnect();
//         el.removeEventListener("scroll", checkOverflow);
//         window.removeEventListener("resize", checkOverflow);
//       };
//     }, []);
  
//     // Subscribe to editor state changes so the toolbar re-renders on
//     // every selection/transaction. Without this, isActive() values go stale
//     // and active highlights freeze.
//     const editorState = useEditorState({
//       editor,
//       selector: (ctx) => {
//         if (!ctx.editor) return null;
//         const e = ctx.editor;
//         return {
//           canUndo: e.can().undo(),
//           canRedo: e.can().redo(),
//           isBold: e.isActive("bold"),
//           isItalic: e.isActive("italic"),
//           isUnderline: e.isActive("underline"),
//           isStrike: e.isActive("strike"),
//           isBulletList: e.isActive("bulletList"),
//           isOrderedList: e.isActive("orderedList"),
//           isBlockquote: e.isActive("blockquote"),
//           isCodeBlock: e.isActive("codeBlock"),
//           isLink: e.isActive("link"),
//           isAlignLeft: e.isActive({ textAlign: "left" }),
//           isAlignCenter: e.isActive({ textAlign: "center" }),
//           isAlignRight: e.isActive({ textAlign: "right" }),
//           isInTable: e.isActive("table"),
//           currentHeading:
//             [1, 2, 3, 4, 5, 6].find((l) =>
//               e.isActive("heading", { level: l })
//             ) || 0,
//         };
//       },
//     });
  
//     if (!editor || !editorState) return null;
  
//     const setHeading = (level) => {
//       if (level === 0) {
//         editor.chain().focus().setParagraph().run();
//       } else {
//         editor.chain().focus().toggleHeading({ level }).run();
//       }
//     };
  
//     const insertImage = () => {
//       const input = document.createElement("input");
//       input.type = "file";
//       input.accept = "image/*";
//       input.onchange = async (e) => {
//         const file = e.target.files?.[0];
//         if (!file) return;
//         const url = await onImageUpload(file);
//         if (url) editor.chain().focus().setImage({ src: url }).run();
//       };
//       input.click();
//     };
  
//     const insertTable = () => {
//       editor
//         .chain()
//         .focus()
//         .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
//         .run();
//     };
  
//     const setLink = () => {
//       const previous = editor.getAttributes("link").href;
//       const url = window.prompt("Enter URL", previous || "");
//       if (url === null) return;
//       if (url === "") {
//         editor.chain().focus().extendMarkRange("link").unsetLink().run();
//         return;
//       }
//       editor
//         .chain()
//         .focus()
//         .extendMarkRange("link")
//         .setLink({ href: url })
//         .run();
//     };

//     return (
//       <div className={`toolbar-wrapper ${hasOverflow ? "has-overflow" : ""}`}>
//         <div
//           ref={scrollRef}
//           className="flex items-center gap-0.5 px-3 py-2 border-b border-gray-200 bg-white sticky top-0 z-10 overflow-x-auto overflow-y-hidden whitespace-nowrap toolbar-scroll"
//         >
//           <ToolbarButton
//           onClick={() => editor.chain().focus().undo().run()}
//           disabled={!editorState.canUndo}
//           title="Undo (Ctrl+Z)"
//         >
//           <Undo2 size={ICON_SIZE} />
//         </ToolbarButton>
//         <ToolbarButton
//           onClick={() => editor.chain().focus().redo().run()}
//           disabled={!editorState.canRedo}
//           title="Redo (Ctrl+Y)"
//         >
//           <Redo2 size={ICON_SIZE} />
//         </ToolbarButton>
  
//         <Divider />
  
//         <select
//           value={editorState.currentHeading}
//           onChange={(e) => setHeading(Number(e.target.value))}
//           title="Text style"
//           className="shrink-0 h-8 px-2 text-sm font-outfit border border-gray-200 rounded-md text-gray-700 bg-white hover:border-[#C95EBE] focus:outline-none focus:border-[#C95EBE] focus:ring-1 focus:ring-[#C95EBE] cursor-pointer"
//         >
//           <option value={0}>Paragraph</option>
//           <option value={1}>Heading 1</option>
//           <option value={2}>Heading 2</option>
//           <option value={3}>Heading 3</option>
//           <option value={4}>Heading 4</option>
//         </select>
  
//         <Divider />
  
//         <ToolbarButton
//           onClick={() => editor.chain().focus().toggleBold().run()}
//           active={editorState.isBold}
//           title="Bold (Ctrl+B)"
//         >
//           <Bold size={ICON_SIZE} />
//         </ToolbarButton>
//         <ToolbarButton
//           onClick={() => editor.chain().focus().toggleItalic().run()}
//           active={editorState.isItalic}
//           title="Italic (Ctrl+I)"
//         >
//           <Italic size={ICON_SIZE} />
//         </ToolbarButton>
//         <ToolbarButton
//           onClick={() => editor.chain().focus().toggleUnderline().run()}
//           active={editorState.isUnderline}
//           title="Underline (Ctrl+U)"
//         >
//           <UnderlineIcon size={ICON_SIZE} />
//         </ToolbarButton>
//         <ToolbarButton
//           onClick={() => editor.chain().focus().toggleStrike().run()}
//           active={editorState.isStrike}
//           title="Strikethrough"
//         >
//           <Strikethrough size={ICON_SIZE} />
//         </ToolbarButton>
  
//         <Divider />
  
//         <ToolbarButton
//           onClick={() => editor.chain().focus().setTextAlign("left").run()}
//           active={editorState.isAlignLeft}
//           title="Align left"
//         >
//           <AlignLeft size={ICON_SIZE} />
//         </ToolbarButton>
//         <ToolbarButton
//           onClick={() => editor.chain().focus().setTextAlign("center").run()}
//           active={editorState.isAlignCenter}
//           title="Align center"
//         >
//           <AlignCenter size={ICON_SIZE} />
//         </ToolbarButton>
//         <ToolbarButton
//           onClick={() => editor.chain().focus().setTextAlign("right").run()}
//           active={editorState.isAlignRight}
//           title="Align right"
//         >
//           <AlignRight size={ICON_SIZE} />
//         </ToolbarButton>
  
//         <Divider />
  
//         <ToolbarButton
//           onClick={() => editor.chain().focus().toggleBulletList().run()}
//           active={editorState.isBulletList}
//           title="Bullet list"
//         >
//           <List size={ICON_SIZE} />
//         </ToolbarButton>
//         <ToolbarButton
//           onClick={() => editor.chain().focus().toggleOrderedList().run()}
//           active={editorState.isOrderedList}
//           title="Numbered list"
//         >
//           <ListOrdered size={ICON_SIZE} />
//         </ToolbarButton>
//         <ToolbarButton
//           onClick={() => editor.chain().focus().toggleBlockquote().run()}
//           active={editorState.isBlockquote}
//           title="Blockquote"
//         >
//           <Quote size={ICON_SIZE} />
//         </ToolbarButton>
//         <ToolbarButton
//           onClick={() => editor.chain().focus().toggleCodeBlock().run()}
//           active={editorState.isCodeBlock}
//           title="Code block"
//         >
//           <Code size={ICON_SIZE} />
//         </ToolbarButton>
  
//         <Divider />
  
//         <ToolbarButton
//           onClick={setLink}
//           active={editorState.isLink}
//           title="Link"
//         >
//           <LinkIcon size={ICON_SIZE} />
//         </ToolbarButton>
//         <ToolbarButton onClick={insertImage} title="Insert image">
//           <ImageIcon size={ICON_SIZE} />
//         </ToolbarButton>
//         <ToolbarButton onClick={insertTable} title="Insert table">
//           <TableIcon size={ICON_SIZE} />
//         </ToolbarButton>
  
//         {editorState.isInTable && (
//           <>
//             <Divider />
//             <ToolbarButton
//               onClick={() => editor.chain().focus().addColumnAfter().run()}
//               title="Add column after"
//             >
//               <span className="inline-flex items-center">
//                 <Plus size={12} className="-mr-0.5" />
//                 <Columns3 size={ICON_SIZE} />
//               </span>
//             </ToolbarButton>
//             <ToolbarButton
//               onClick={() => editor.chain().focus().deleteColumn().run()}
//               title="Delete column"
//             >
//               <span className="inline-flex items-center">
//                 <Minus size={12} className="-mr-0.5" />
//                 <Columns3 size={ICON_SIZE} />
//               </span>
//             </ToolbarButton>
//             <ToolbarButton
//               onClick={() => editor.chain().focus().addRowAfter().run()}
//               title="Add row after"
//             >
//               <span className="inline-flex items-center">
//                 <Plus size={12} className="-mr-0.5" />
//                 <Rows3 size={ICON_SIZE} />
//               </span>
//             </ToolbarButton>
//             <ToolbarButton
//               onClick={() => editor.chain().focus().deleteRow().run()}
//               title="Delete row"
//             >
//               <span className="inline-flex items-center">
//                 <Minus size={12} className="-mr-0.5" />
//                 <Rows3 size={ICON_SIZE} />
//               </span>
//             </ToolbarButton>
//             <ToolbarButton
//               onClick={() => editor.chain().focus().deleteTable().run()}
//               title="Delete table"
//             >
//               <Trash2 size={ICON_SIZE} />
//             </ToolbarButton>
//           </>
//         )}
  
//         <Divider />
  
//         <ToolbarButton
//           onClick={() =>
//             editor.chain().focus().unsetAllMarks().clearNodes().run()
//           }
//           title="Clear formatting"
//         >
//           <Eraser size={ICON_SIZE} />
//         </ToolbarButton>
//         </div>
//       </div>
//     );
//   };
  
//   /* ──────────────────────────────────────────────────────────────────
//      Editor styles  (kept inline since they target Tiptap's ProseMirror DOM)
//      ────────────────────────────────────────────────────────────────── */
  
//   const EDITOR_STYLES = `
//     /* ── Toolbar scroll ─────────────────────────────────────────── */
//     .toolbar-scroll {
//       scrollbar-width: thin;
//       scrollbar-color: #E5E7EB transparent;
//     }
//     .toolbar-scroll::-webkit-scrollbar {
//       height: 4px;
//     }
//     .toolbar-scroll::-webkit-scrollbar-track {
//       background: transparent;
//     }
//     .toolbar-scroll::-webkit-scrollbar-thumb {
//       background-color: #E5E7EB;
//       border-radius: 2px;
//     }
//     .toolbar-scroll::-webkit-scrollbar-thumb:hover {
//       background-color: #C95EBE;
//     }
//     /* Right-edge fade hint that more icons exist */
//     .toolbar-wrapper {
//       position: relative;
//     }
//     .toolbar-wrapper::after {
//       content: "";
//       position: absolute;
//       top: 0;
//       right: 0;
//       bottom: 0;
//       width: 24px;
//       background: linear-gradient(to right, transparent, white);
//       pointer-events: none;
//       opacity: 0;
//       transition: opacity 0.2s;
//     }
//     .toolbar-wrapper.has-overflow::after {
//       opacity: 1;
//     }
  
//     /* ── Editor content ─────────────────────────────────────────── */
//     .proposal-editor .ProseMirror {
//       min-height: 100%;
//       padding: 24px;
//       font-family: 'Outfit', sans-serif;
//       font-size: 14px;
//       line-height: 1.7;
//       color: #374151;
//       outline: none;
//     }
//     .proposal-editor .ProseMirror h1 { font-size: 24px; font-weight: 700; margin: 18px 0 12px; color: #111827; }
//     .proposal-editor .ProseMirror h2 { font-size: 20px; font-weight: 700; margin: 16px 0 10px; color: #111827; }
//     .proposal-editor .ProseMirror h3 { font-size: 16px; font-weight: 600; margin: 14px 0 8px; color: #111827; }
//     .proposal-editor .ProseMirror h4 { font-size: 15px; font-weight: 700; margin: 14px 0 8px; color: #111827; }
//     .proposal-editor .ProseMirror p { margin: 0 0 10px 0; }
//     .proposal-editor .ProseMirror ul, .proposal-editor .ProseMirror ol { margin: 8px 0 12px 22px; padding: 0; }
//     .proposal-editor .ProseMirror li { margin: 4px 0; }
//     .proposal-editor .ProseMirror strong { font-weight: 700; }
//     .proposal-editor .ProseMirror em { font-style: italic; }
//     .proposal-editor .ProseMirror table {
//       border-collapse: collapse;
//       width: 100%;
//       margin: 16px 0;
//       table-layout: fixed;
//       overflow: hidden;
//     }
//     .proposal-editor .ProseMirror table td,
//     .proposal-editor .ProseMirror table th {
//       border: 1px solid #d1d5db;
//       padding: 10px;
//       vertical-align: top;
//       position: relative;
//     }
//     .proposal-editor .ProseMirror table th {
//       background-color: #f9fafb;
//       font-weight: 600;
//       color: #111827;
//       text-align: left;
//     }
//     .proposal-editor .ProseMirror img { max-width: 100%; height: auto; }
//     .proposal-editor .ProseMirror blockquote {
//       border-left: 3px solid #C95EBE;
//       padding-left: 12px;
//       margin: 12px 0;
//       color: #6B7280;
//     }
//     .proposal-editor .ProseMirror pre {
//       background: #1F2937;
//       color: #F9FAFB;
//       padding: 12px;
//       border-radius: 6px;
//       overflow-x: auto;
//       font-family: ui-monospace, SFMono-Regular, monospace;
//     }
//     .proposal-editor .ProseMirror a { color: #C95EBE; text-decoration: underline; }
//     .proposal-editor .ProseMirror p.is-editor-empty:first-child::before {
//       color: #9CA3AF;
//       content: attr(data-placeholder);
//       float: left;
//       height: 0;
//       pointer-events: none;
//     }
//   `;
  
//   /* ──────────────────────────────────────────────────────────────────
//      Editor
//      ────────────────────────────────────────────────────────────────── */
  
//   const ProposalEditor = forwardRef(
//     ({ initialContent, onChange, onReady, onImageUpload }, ref) => {
//       const editor = useEditor({
//         extensions: [
//           StarterKit.configure({
//             heading: { levels: [1, 2, 3, 4, 5, 6] },
//           }),
//           Underline,
//           TextStyle,
//           Color,
//           Image.configure({ inline: false, allowBase64: true }),
//           Link.configure({ openOnClick: false, autolink: true }),
//           TextAlign.configure({ types: ["heading", "paragraph"] }),
//           Table.configure({ resizable: true }),
//           TableRow,
//           TableHeader,
//           TableCell,
//           Placeholder.configure({
//             placeholder: "Start editing your proposal...",
//           }),
//         ],
//         content: initialContent || "",
//         onUpdate: ({ editor: e }) => {
//           onChange?.(e.getHTML());
//         },
//       });
  
//       // Notify parent once the editor is ready so it can capture the
//       // initial normalized content for dirty-checking.
//       useEffect(() => {
//         if (editor && onReady) onReady(editor);
//       }, [editor, onReady]);
  
//       // Imperative API for the parent
//       useImperativeHandle(
//         ref,
//         () => ({
//           getContent: () => editor?.getHTML() ?? "",
//           setContent: (html) => {
//             if (!editor) return;
//             editor.commands.setContent(html || "", false);
//           },
//           clearHistory: () => {
//             // Tiptap doesn't expose undoManager.clear() directly; resetting
//             // content with the second arg false skips history, but to truly
//             // wipe history we re-create the doc state.
//             if (!editor) return;
//             const html = editor.getHTML();
//             editor.commands.setContent(html, false);
//           },
//           focus: () => editor?.commands.focus(),
//           editor,
//         }),
//         [editor]
//       );
  
//       // Default image upload handler — base64. Replace with real upload via prop.
//       const handleImageUpload = useCallback(
//         async (file) => {
//           if (onImageUpload) return onImageUpload(file);
//           return new Promise((resolve) => {
//             const reader = new FileReader();
//             reader.onload = () => resolve(reader.result);
//             reader.readAsDataURL(file);
//           });
//         },
//         [onImageUpload]
//       );
  
//       return (
//         <div className="proposal-editor h-full flex flex-col">
//           <style>{EDITOR_STYLES}</style>
//           <Toolbar editor={editor} onImageUpload={handleImageUpload} />
//           <div className="flex-1 overflow-y-auto custom-scrollbar">
//             <EditorContent editor={editor} className="h-full" />
//           </div>
//         </div>
//       );
//     }
//   );
  
//   ProposalEditor.displayName = "ProposalEditor";
  
//   export default ProposalEditor;

import React, {
    forwardRef,
    useImperativeHandle,
    useEffect,
    useCallback,
    useRef,
    useState,
    useMemo,
  } from "react";
  import { createPortal } from "react-dom";
  import { useEditor, EditorContent, useEditorState } from "@tiptap/react";
  import { StarterKit } from "@tiptap/starter-kit";
  import { Image } from "@tiptap/extension-image";
  import { Link } from "@tiptap/extension-link";
  import { TextAlign } from "@tiptap/extension-text-align";
  import { Underline } from "@tiptap/extension-underline";
  import { Color, TextStyle } from "@tiptap/extension-text-style";
  import {
    Table,
    TableRow,
    TableCell,
    TableHeader,
  } from "@tiptap/extension-table";
  import { Placeholder } from "@tiptap/extension-placeholder";
  import {
    Undo2,
    Redo2,
    Bold,
    Italic,
    Underline as UnderlineIcon,
    Strikethrough,
    AlignLeft,
    AlignCenter,
    AlignRight,
    List,
    ListOrdered,
    Quote,
    Code,
    Link as LinkIcon,
    Image as ImageIcon,
    Table as TableIcon,
    Eraser,
    Columns3,
    Rows3,
    Trash2,
    Plus,
    Minus,
    FileText,
    Loader2,
    Heading1,
    Heading2,
    Heading3,
  } from "lucide-react";
  import api from "../../../chat/api";
  import { pdfToImageBlobs } from "./pdfResume";

  /* ──────────────────────────────────────────────────────────────────
     Shared image / PDF helpers (used by the toolbar, slash menu and
     paste/drop handlers so the upload logic lives in exactly one place)
     ────────────────────────────────────────────────────────────────── */

  // Upload one image file to the folder-scoped editor image endpoint and return
  // its hosted URL. Keeps the saved HTML light (a short URL instead of a giant
  // base64 blob).
  async function uploadEditorImage(file, folderId, filename) {
    const form = new FormData();
    form.append("image", file, filename || file.name || "image.png");
    const { data } = await api.post(
      `api/v1/rfp/folders/${folderId}/editor/upload-image/`,
      form
    );
    return data.url;
  }

  // Base64 fallback for when there's no folder context to upload against.
  function fileToDataUrl(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });
  }

  // File-picker → upload (or base64 fallback) → insert a single image.
  function pickAndInsertImage(editor, folderId, { onBusy } = {}) {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/png,image/jpeg,image/webp";
    input.onchange = async (e) => {
      const file = e.target.files?.[0];
      if (!file) return;
      try {
        onBusy?.(true);
        const url = folderId
          ? await uploadEditorImage(file, folderId, file.name)
          : await fileToDataUrl(file);
        editor.chain().focus().setImage({ src: url }).run();
      } catch (err) {
        console.error("Image upload failed", err);
        window.alert(
          "Could not upload image: " +
            (err?.response?.data?.error || err?.message || "unknown error")
        );
      } finally {
        onBusy?.(false);
      }
    };
    input.click();
  }

  // File-picker → render each PDF page to an image → upload → insert as image
  // blocks so a resume/PDF is embedded exactly as it looks.
  function runResumeInsert(editor, folderId, setProgress) {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "application/pdf";
    input.onchange = async (e) => {
      const file = e.target.files?.[0];
      if (!file) return;
      if (file.type !== "application/pdf") {
        window.alert("Please choose a PDF file.");
        return;
      }
      if (!folderId) {
        window.alert("Cannot insert resume: missing folder context.");
        return;
      }
      setProgress({ done: 0, total: 0 });
      try {
        const pages = await pdfToImageBlobs(file, {
          scale: 2,
          onProgress: (done, total) => setProgress({ done, total }),
        });
        if (!pages.length) throw new Error("The PDF has no pages.");
        const baseName = (file.name || "resume").replace(/\.pdf$/i, "");
        const urls = await Promise.all(
          pages.map((p, i) =>
            uploadEditorImage(p.blob, folderId, `${baseName}-p${i + 1}.png`)
          )
        );
        const html = urls
          .map(
            (u, i) =>
              `<img src="${u}" alt="${(baseName || "Resume").replace(
                /"/g,
                "&quot;"
              )} — page ${i + 1}" />`
          )
          .join("");
        editor.chain().focus().insertContent(html).run();
      } catch (err) {
        console.error("Resume insert failed", err);
        window.alert(
          "Could not insert the PDF: " +
            (err?.response?.data?.error || err?.message || "unknown error")
        );
      } finally {
        setProgress(null);
      }
    };
    input.click();
  }

  /* ──────────────────────────────────────────────────────────────────
     Slash ("/") command menu
     ────────────────────────────────────────────────────────────────── */

  // The command palette shown when you type "/" at the start of a line. Each
  // item's run(editor, ctx) performs the insert; ctx carries folderId + the
  // busy/progress setters for the image and resume actions.
  const SLASH_COMMANDS = [
    { key: "h1", label: "Heading 1", icon: Heading1, keywords: ["title", "h1", "big"], run: (e) => e.chain().focus().toggleHeading({ level: 1 }).run() },
    { key: "h2", label: "Heading 2", icon: Heading2, keywords: ["subtitle", "h2"], run: (e) => e.chain().focus().toggleHeading({ level: 2 }).run() },
    { key: "h3", label: "Heading 3", icon: Heading3, keywords: ["h3"], run: (e) => e.chain().focus().toggleHeading({ level: 3 }).run() },
    { key: "bullet", label: "Bulleted list", icon: List, keywords: ["ul", "unordered", "point"], run: (e) => e.chain().focus().toggleBulletList().run() },
    { key: "ordered", label: "Numbered list", icon: ListOrdered, keywords: ["ol", "number", "step"], run: (e) => e.chain().focus().toggleOrderedList().run() },
    { key: "quote", label: "Quote", icon: Quote, keywords: ["blockquote", "callout"], run: (e) => e.chain().focus().toggleBlockquote().run() },
    { key: "code", label: "Code block", icon: Code, keywords: ["pre", "snippet"], run: (e) => e.chain().focus().toggleCodeBlock().run() },
    { key: "divider", label: "Divider", icon: Minus, keywords: ["hr", "rule", "horizontal", "line"], run: (e) => e.chain().focus().setHorizontalRule().run() },
    { key: "table", label: "Table", icon: TableIcon, keywords: ["grid"], run: (e) => e.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run() },
    { key: "image", label: "Image", icon: ImageIcon, keywords: ["picture", "photo"], run: (e, ctx) => pickAndInsertImage(e, ctx.folderId, { onBusy: ctx.setImgUploading }) },
    { key: "resume", label: "Resume / PDF", icon: FileText, keywords: ["pdf", "cv", "document"], run: (e, ctx) => runResumeInsert(e, ctx.folderId, ctx.setResumeProgress) },
  ];

  function filterSlashCommands(query) {
    const q = (query || "").toLowerCase();
    if (!q) return SLASH_COMMANDS;
    return SLASH_COMMANDS.filter(
      (c) =>
        c.label.toLowerCase().includes(q) ||
        c.keywords.some((k) => k.includes(q))
    );
  }

  // Detect a "/query" being typed at the cursor. Only triggers when the slash is
  // at the start of the block or preceded by whitespace (so "and/or" or a URL
  // won't open the menu). Returns { query, range } or null.
  function getSlashContext(editor) {
    const { state } = editor;
    const sel = state.selection;
    if (!sel.empty) return null;
    const $from = sel.$from;
    if (!$from.parent.isTextblock) return null;
    const textBefore = $from.parent.textBetween(0, $from.parentOffset, "\n", "￼");
    const m = /(?:^|\s)\/([\w-]*)$/.exec(textBefore);
    if (!m) return null;
    const query = m[1];
    const to = sel.from;
    const from = to - (query.length + 1); // include the "/"
    return { query, range: { from, to } };
  }
  
  /* ──────────────────────────────────────────────────────────────────
     Toolbar
     ────────────────────────────────────────────────────────────────── */
  
  const ToolbarButton = ({ onClick, active, disabled, title, children }) => (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={title}
      aria-pressed={active}
      className={`inline-flex shrink-0 items-center justify-center w-8 h-8 rounded-md transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${
        active
          ? "bg-[#C95EBE] text-white shadow-sm"
          : "text-gray-600 hover:bg-purple-50 hover:text-[#C95EBE]"
      }`}
    >
      {children}
    </button>
  );
  
  const Divider = () => <div className="w-px h-5 bg-gray-200 mx-1 shrink-0" />;
  
  const ICON_SIZE = 16;
  
  const Toolbar = ({
    editor,
    folderId,
    resumeProgress,
    setResumeProgress,
  }) => {
    const scrollRef = useRef(null);
    const [hasOverflow, setHasOverflow] = useState(false);
    // Spinner on the image button while an upload is in flight.
    const [imgBusy, setImgBusy] = useState(false);
  
    // Detect whether the toolbar overflows so we can show a fade hint on the right edge.
    useEffect(() => {
      const el = scrollRef.current;
      if (!el) return undefined;
  
      const checkOverflow = () => {
        const overflowing = el.scrollWidth > el.clientWidth;
        const scrolledToEnd =
          el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
        setHasOverflow(overflowing && !scrolledToEnd);
      };
  
      checkOverflow();
  
      // Re-check when the editor toolbar grows/shrinks (e.g. table buttons appear)
      const ro = new ResizeObserver(checkOverflow);
      ro.observe(el);
  
      el.addEventListener("scroll", checkOverflow, { passive: true });
      window.addEventListener("resize", checkOverflow);
  
      return () => {
        ro.disconnect();
        el.removeEventListener("scroll", checkOverflow);
        window.removeEventListener("resize", checkOverflow);
      };
    }, []);
  
    // Subscribe to editor state changes so the toolbar re-renders on
    // every selection/transaction. Without this, isActive() values go stale
    // and active highlights freeze.
    const editorState = useEditorState({
      editor,
      selector: (ctx) => {
        if (!ctx.editor) return null;
        const e = ctx.editor;
        return {
          canUndo: e.can().undo(),
          canRedo: e.can().redo(),
          isBold: e.isActive("bold"),
          isItalic: e.isActive("italic"),
          isUnderline: e.isActive("underline"),
          isStrike: e.isActive("strike"),
          isBulletList: e.isActive("bulletList"),
          isOrderedList: e.isActive("orderedList"),
          isBlockquote: e.isActive("blockquote"),
          isCodeBlock: e.isActive("codeBlock"),
          isLink: e.isActive("link"),
          isAlignLeft: e.isActive({ textAlign: "left" }),
          isAlignCenter: e.isActive({ textAlign: "center" }),
          isAlignRight: e.isActive({ textAlign: "right" }),
          isInTable: e.isActive("table"),
          currentHeading:
            [1, 2, 3, 4, 5, 6].find((l) =>
              e.isActive("heading", { level: l })
            ) || 0,
        };
      },
    });
  
    if (!editor || !editorState) return null;
  
    const setHeading = (level) => {
      if (level === 0) {
        editor.chain().focus().setParagraph().run();
      } else {
        editor.chain().focus().toggleHeading({ level }).run();
      }
    };
  
    const insertImage = () =>
      pickAndInsertImage(editor, folderId, { onBusy: setImgBusy });
  
    const insertTable = () => {
      editor
        .chain()
        .focus()
        .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
        .run();
    };

    // Insert a PDF (e.g. a resume) "as it is" — see runResumeInsert().
    const insertResume = () => {
      if (resumeProgress) return; // already running
      runResumeInsert(editor, folderId, setResumeProgress);
    };
  
    const setLink = () => {
      const previous = editor.getAttributes("link").href;
      const url = window.prompt("Enter URL", previous || "");
      if (url === null) return;
      if (url === "") {
        editor.chain().focus().extendMarkRange("link").unsetLink().run();
        return;
      }
      editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({ href: url })
        .run();
    };

    return (
      <div className={`toolbar-wrapper ${hasOverflow ? "has-overflow" : ""}`}>
        <div
          ref={scrollRef}
          className="flex items-center gap-0.5 px-3 py-2 border-b border-gray-200 bg-white sticky top-0 z-10 overflow-x-auto overflow-y-hidden whitespace-nowrap toolbar-scroll"
        >
          <ToolbarButton
          onClick={() => editor.chain().focus().undo().run()}
          disabled={!editorState.canUndo}
          title="Undo (Ctrl+Z)"
        >
          <Undo2 size={ICON_SIZE} />
        </ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().redo().run()}
          disabled={!editorState.canRedo}
          title="Redo (Ctrl+Y)"
        >
          <Redo2 size={ICON_SIZE} />
        </ToolbarButton>
  
        <Divider />
  
        <select
          value={editorState.currentHeading}
          onChange={(e) => setHeading(Number(e.target.value))}
          title="Text style"
          className="shrink-0 h-8 px-2 text-sm font-outfit border border-gray-200 rounded-md text-gray-700 bg-white hover:border-[#C95EBE] focus:outline-none focus:border-[#C95EBE] focus:ring-1 focus:ring-[#C95EBE] cursor-pointer"
        >
          <option value={0}>Paragraph</option>
          <option value={1}>Heading 1</option>
          <option value={2}>Heading 2</option>
          <option value={3}>Heading 3</option>
          <option value={4}>Heading 4</option>
        </select>
  
        <Divider />
  
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleBold().run()}
          active={editorState.isBold}
          title="Bold (Ctrl+B)"
        >
          <Bold size={ICON_SIZE} />
        </ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleItalic().run()}
          active={editorState.isItalic}
          title="Italic (Ctrl+I)"
        >
          <Italic size={ICON_SIZE} />
        </ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleUnderline().run()}
          active={editorState.isUnderline}
          title="Underline (Ctrl+U)"
        >
          <UnderlineIcon size={ICON_SIZE} />
        </ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleStrike().run()}
          active={editorState.isStrike}
          title="Strikethrough"
        >
          <Strikethrough size={ICON_SIZE} />
        </ToolbarButton>
  
        <Divider />
  
        <ToolbarButton
          onClick={() => editor.chain().focus().setTextAlign("left").run()}
          active={editorState.isAlignLeft}
          title="Align left"
        >
          <AlignLeft size={ICON_SIZE} />
        </ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().setTextAlign("center").run()}
          active={editorState.isAlignCenter}
          title="Align center"
        >
          <AlignCenter size={ICON_SIZE} />
        </ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().setTextAlign("right").run()}
          active={editorState.isAlignRight}
          title="Align right"
        >
          <AlignRight size={ICON_SIZE} />
        </ToolbarButton>
  
        <Divider />
  
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          active={editorState.isBulletList}
          title="Bullet list"
        >
          <List size={ICON_SIZE} />
        </ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          active={editorState.isOrderedList}
          title="Numbered list"
        >
          <ListOrdered size={ICON_SIZE} />
        </ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleBlockquote().run()}
          active={editorState.isBlockquote}
          title="Blockquote"
        >
          <Quote size={ICON_SIZE} />
        </ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleCodeBlock().run()}
          active={editorState.isCodeBlock}
          title="Code block"
        >
          <Code size={ICON_SIZE} />
        </ToolbarButton>
  
        <Divider />
  
        <ToolbarButton
          onClick={setLink}
          active={editorState.isLink}
          title="Link"
        >
          <LinkIcon size={ICON_SIZE} />
        </ToolbarButton>
        <ToolbarButton
          onClick={insertImage}
          disabled={imgBusy}
          title="Insert image"
        >
          {imgBusy ? (
            <Loader2 size={ICON_SIZE} className="animate-spin" />
          ) : (
            <ImageIcon size={ICON_SIZE} />
          )}
        </ToolbarButton>
        <ToolbarButton
          onClick={insertResume}
          disabled={!folderId || !!resumeProgress}
          title={
            folderId
              ? "Insert resume / PDF (keeps original layout)"
              : "Insert resume — unavailable (missing folder)"
          }
        >
          {resumeProgress ? (
            <Loader2 size={ICON_SIZE} className="animate-spin" />
          ) : (
            <FileText size={ICON_SIZE} />
          )}
        </ToolbarButton>
        {resumeProgress && (
          <span className="shrink-0 ml-1 text-xs font-outfit text-[#A04A97] tabular-nums whitespace-nowrap">
            {resumeProgress.total
              ? `Adding page ${resumeProgress.done}/${resumeProgress.total}…`
              : "Reading PDF…"}
          </span>
        )}
        <ToolbarButton onClick={insertTable} title="Insert table">
          <TableIcon size={ICON_SIZE} />
        </ToolbarButton>
  
        {editorState.isInTable && (
          <>
            <Divider />
            <ToolbarButton
              onClick={() => editor.chain().focus().addColumnAfter().run()}
              title="Add column after"
            >
              <span className="inline-flex items-center">
                <Plus size={12} className="-mr-0.5" />
                <Columns3 size={ICON_SIZE} />
              </span>
            </ToolbarButton>
            <ToolbarButton
              onClick={() => editor.chain().focus().deleteColumn().run()}
              title="Delete column"
            >
              <span className="inline-flex items-center">
                <Minus size={12} className="-mr-0.5" />
                <Columns3 size={ICON_SIZE} />
              </span>
            </ToolbarButton>
            <ToolbarButton
              onClick={() => editor.chain().focus().addRowAfter().run()}
              title="Add row after"
            >
              <span className="inline-flex items-center">
                <Plus size={12} className="-mr-0.5" />
                <Rows3 size={ICON_SIZE} />
              </span>
            </ToolbarButton>
            <ToolbarButton
              onClick={() => editor.chain().focus().deleteRow().run()}
              title="Delete row"
            >
              <span className="inline-flex items-center">
                <Minus size={12} className="-mr-0.5" />
                <Rows3 size={ICON_SIZE} />
              </span>
            </ToolbarButton>
            <ToolbarButton
              onClick={() => editor.chain().focus().deleteTable().run()}
              title="Delete table"
            >
              <Trash2 size={ICON_SIZE} />
            </ToolbarButton>
          </>
        )}
  
        <Divider />
  
        <ToolbarButton
          onClick={() =>
            editor.chain().focus().unsetAllMarks().clearNodes().run()
          }
          title="Clear formatting"
        >
          <Eraser size={ICON_SIZE} />
        </ToolbarButton>
        </div>
      </div>
    );
  };
  
  /* ──────────────────────────────────────────────────────────────────
     Editor styles  (kept inline since they target Tiptap's ProseMirror DOM)
     ────────────────────────────────────────────────────────────────── */
  
  const EDITOR_STYLES = `
    /* ── Toolbar scroll ─────────────────────────────────────────── */
    .toolbar-scroll {
      scrollbar-width: thin;
      scrollbar-color: #E5E7EB transparent;
    }
    .toolbar-scroll::-webkit-scrollbar {
      height: 4px;
    }
    .toolbar-scroll::-webkit-scrollbar-track {
      background: transparent;
    }
    .toolbar-scroll::-webkit-scrollbar-thumb {
      background-color: #E5E7EB;
      border-radius: 2px;
    }
    .toolbar-scroll::-webkit-scrollbar-thumb:hover {
      background-color: #C95EBE;
    }
    /* Right-edge fade hint that more icons exist */
    .toolbar-wrapper {
      position: relative;
    }
    .toolbar-wrapper::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: 24px;
      background: linear-gradient(to right, transparent, white);
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.2s;
    }
    .toolbar-wrapper.has-overflow::after {
      opacity: 1;
    }
  
    /* ── Editor content ─────────────────────────────────────────── */
    .proposal-editor .ProseMirror {
      min-height: 100%;
      padding: 24px;
      font-family: 'Outfit', sans-serif;
      font-size: 15px;
      line-height: 1.7;
      color: #374151;
      outline: none;
    }
    .proposal-editor .ProseMirror h1 { font-size: 24px; font-weight: 700; margin: 18px 0 12px; color: #111827; }
    .proposal-editor .ProseMirror h2 { font-size: 20px; font-weight: 700; margin: 16px 0 10px; color: #111827; }
    .proposal-editor .ProseMirror h3 { font-size: 16px; font-weight: 600; margin: 14px 0 8px; color: #111827; }
    .proposal-editor .ProseMirror h4 { font-size: 15px; font-weight: 700; margin: 14px 0 8px; color: #111827; }
    .proposal-editor .ProseMirror p { margin: 0 0 10px 0; }
    .proposal-editor .ProseMirror ul, .proposal-editor .ProseMirror ol { margin: 8px 0 12px 0; padding-left: 24px; list-style-position: outside; }
    .proposal-editor .ProseMirror ul { list-style: disc; }
    .proposal-editor .ProseMirror ol { list-style: decimal; }
    .proposal-editor .ProseMirror li { margin: 4px 0; }
    .proposal-editor .ProseMirror li p { margin: 0; }
    .proposal-editor .ProseMirror strong { font-weight: 700; }
    .proposal-editor .ProseMirror em { font-style: italic; }
    .proposal-editor .ProseMirror table {
      border-collapse: collapse;
      width: 100%;
      margin: 16px 0;
      table-layout: fixed;
      overflow: hidden;
    }
    .proposal-editor .ProseMirror table td,
    .proposal-editor .ProseMirror table th {
      border: 1px solid #d1d5db;
      padding: 10px;
      vertical-align: top;
      position: relative;
    }
    .proposal-editor .ProseMirror table th {
      background-color: #f9fafb;
      font-weight: 600;
      color: #111827;
      text-align: left;
    }
    .proposal-editor .ProseMirror img { max-width: 100%; height: auto; }
    .proposal-editor .ProseMirror blockquote {
      border-left: 3px solid #C95EBE;
      padding-left: 12px;
      margin: 12px 0;
      color: #6B7280;
    }
    .proposal-editor .ProseMirror pre {
      background: #1F2937;
      color: #F9FAFB;
      padding: 12px;
      border-radius: 6px;
      overflow-x: auto;
      font-family: ui-monospace, SFMono-Regular, monospace;
    }
    .proposal-editor .ProseMirror a { color: #C95EBE; text-decoration: underline; }
    .proposal-editor .ProseMirror img {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 8px auto;
      border-radius: 4px;
    }
    .proposal-editor .ProseMirror img.ProseMirror-selectednode {
      outline: 2px solid #C95EBE;
    }
    .proposal-editor .ProseMirror p.is-editor-empty:first-child::before {
      color: #9CA3AF;
      content: attr(data-placeholder);
      float: left;
      height: 0;
      pointer-events: none;
    }
    .proposal-editor.proposal-continuous .ProseMirror { min-height: 0; padding-top: 2px; }
    /* Section bodies stay flush with their heading (both 24px in); a subsection's
       body is indented to sit under its own heading, so the hierarchy is legible
       from the left edge alone without any extra rules or markers. */
    .proposal-editor .proposal-node-sub .ProseMirror { padding-left: 48px; }
    @keyframes proposal-editor-enter-down {
      from { opacity: 0; transform: translateY(10px); }
      to { opacity: 1; transform: translateY(0); }
    }
    @keyframes proposal-editor-enter-up {
      from { opacity: 0; transform: translateY(-10px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;
  
  /* ──────────────────────────────────────────────────────────────────
     Slash menu popup — rendered to <body> so it isn't clipped by the
     editor's scroll container. Positioned at the caret via coordsAtPos.
     ────────────────────────────────────────────────────────────────── */

  const SlashMenu = ({ slash, items, activeIndex, onPick }) => {
    if (!slash || !slash.coords || items.length === 0) return null;
    const { coords } = slash;
    const MENU_MAX_H = 320;
    const openUp = coords.bottom + MENU_MAX_H > window.innerHeight;
    const style = {
      position: "fixed",
      left: Math.max(8, Math.min(coords.left, window.innerWidth - 232)),
      zIndex: 9999,
      ...(openUp
        ? { bottom: window.innerHeight - coords.top + 6 }
        : { top: coords.bottom + 6 }),
    };
    return createPortal(
      <div
        style={style}
        className="w-56 max-h-80 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg py-1 font-outfit"
      >
        {items.map((it, i) => {
          const Icon = it.icon;
          return (
            <button
              key={it.key}
              type="button"
              // onMouseDown (not onClick) + preventDefault keeps editor focus
              // so the command applies to the right selection.
              onMouseDown={(e) => {
                e.preventDefault();
                onPick(it);
              }}
              className={`w-full flex items-center gap-2.5 px-3 py-1.5 text-left text-sm ${
                i === activeIndex
                  ? "bg-purple-50 text-[#A04A97]"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
            >
              <Icon size={15} className="shrink-0" />
              <span>{it.label}</span>
            </button>
          );
        })}
      </div>,
      document.body
    );
  };

  /* ──────────────────────────────────────────────────────────────────
     Editor
     ────────────────────────────────────────────────────────────────── */

  // Breathing room above a node, in px. Matches the scroll container's pt-4 and
  // is the strip the hover toolbar floats into, so it must be kept in step with
  // both the container padding and NodeActions' -top-2 offset.
  const NODE_TOP_GUTTER = 16;

  // Unnumbered nodes (e.g. a Cover Letter) come back with a "U" prefix on the
  // number — the sidebar hides those, so the document must too.
  const displayNumber = (num) => {
    const clean = String(num ?? "").replace(/\.+$/, "");
    return /^U/i.test(clean) ? "" : clean;
  };

  // One node's heading. Depth drives the whole hierarchy: a section (depth 0)
  // reads as a document heading and sits flush with its body, while a
  // subsection (depth 1) is smaller and indented under its parent. The number
  // is set in a lighter tone so the title stays the thing you actually scan.
  const NodeHeading = ({ nodeId, number, title, depth = 0 }) => {
    const isSub = depth === 1;
    const num = displayNumber(number);
    return (
      <div
        data-proposal-node-id={nodeId}
        className={`font-outfit ${
          isSub
            ? "pl-12 pr-6 pt-5 pb-1 text-[16px] font-semibold text-[#3F3F46]"
            : "px-6 pt-7 pb-2 text-[22px] font-semibold text-[#111827] tracking-[-0.01em]"
        }`}
      >
        {num && (
          <span className="font-normal text-[#A1A1AA] tabular-nums mr-2">{num}</span>
        )}
        {title || "Section"}
      </div>
    );
  };

  // A rule separates whole section groups, not individual nodes: it sits above
  // every top-level section except the first, so 2 / 2.1 / 2.2 read as one block
  // and the next rule announces 3. Subsections never draw one.
  // mt-10 above vs the heading's pt-7 below leaves the rule nearer the section it
  // introduces than the one it closes, so the grouping reads the right way round.
  const groupRule = (depth, indexInDoc) =>
    depth === 1 || indexInDoc === 0 ? "" : "border-t border-[#ECE9EE] mt-10";

  // Containers whose children are blocks, so whitespace between them carries no
  // meaning. Whitespace inside <p>/<li>/<td>/headings IS meaningful (the gap in
  // "<strong>a</strong> <em>b</em>"), so those are deliberately absent.
  const BLOCK_ONLY_PARENTS = new Set([
    "DIV", "UL", "OL", "TABLE", "THEAD", "TBODY", "TFOOT", "TR", "SECTION", "FIGURE", "BLOCKQUOTE",
  ]);

  // ProseMirror's stylesheet puts `white-space: pre-wrap` on .ProseMirror, and the
  // inert nodes borrow that class for styling — so the newlines Markdown leaves
  // between block tags render as REAL blank lines. The live editor never shows
  // them because ProseMirror rebuilds the DOM from its own model, which is why a
  // node visibly collapsed the moment you clicked into it. Drop exactly those
  // insignificant whitespace nodes so the before/after states match.
  const stripBlockGaps = (html) => {
    if (!html || typeof window === "undefined" || typeof window.DOMParser !== "function") return html;
    try {
      const root = new window.DOMParser()
        .parseFromString(`<div id="r">${html}</div>`, "text/html")
        .getElementById("r");
      const walk = (el) => {
        if (el.tagName === "PRE") return;   // whitespace is the point in <pre>
        const strip = BLOCK_ONLY_PARENTS.has(el.tagName);
        Array.from(el.childNodes).forEach((n) => {
          if (n.nodeType === 3) {
            if (strip && !n.nodeValue.trim()) el.removeChild(n);
          } else if (n.nodeType === 1) {
            walk(n);
          }
        });
      };
      walk(root);
      return root.innerHTML;
    } catch (err) {
      return html;   // never blank a section over a parsing hiccup
    }
  };

  // Per-node actions, revealed on hover above the node. Previously these lived
  // only in the step bar and acted on "whatever is selected", so acting on a node
  // meant selecting it first — a click that swapped the editor without placing a
  // caret, which is what made text feel like it needed two clicks.
  export const NodeActions = ({
    isDone,
    isBusy,
    hasContent,
    onGenerate,
    onRegenerate,
    onAssign,
    onMarkDone,
  }) => {
    const btn =
      "flex items-center gap-1 px-2 h-7 rounded-md text-[11.5px] font-medium " +
      "text-[#52525B] hover:bg-[#F4F4F5] hover:text-[#18101C] transition-colors " +
      "disabled:opacity-40 disabled:cursor-not-allowed";
    // mousedown is stopped so using the toolbar never moves the caret or
    // re-selects the node underneath it.
    const stop = (e) => e.stopPropagation();
    return (
      <div
        onMouseDown={stop}
        className="absolute right-4 -top-2 z-20 flex items-center gap-0.5 rounded-lg border border-[#ECE9EE] bg-white px-1 py-1 shadow-[0_4px_14px_-6px_rgba(32,10,28,0.35)] opacity-0 pointer-events-none group-hover/node:opacity-100 group-hover/node:pointer-events-auto focus-within:opacity-100 focus-within:pointer-events-auto transition-opacity"
      >
        {/* Nothing written yet → this is a first draft, not a rewrite. The two
            go to different dialogs and different scopes (Generate drafts the
            whole section family; Regenerate rewrites just this node), so the
            label has to match what will actually happen. */}
        {hasContent ? (
          <button type="button" className={btn} disabled={isBusy} onClick={onRegenerate} title="Rewrite this section">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="23 4 23 10 17 10" />
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
            </svg>
            Regenerate
          </button>
        ) : (
          <button type="button" className={btn} disabled={isBusy} onClick={onGenerate} title="Write this section">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3v4M12 17v4M3 12h4M17 12h4" />
              <path d="M6.3 6.3l2.4 2.4M15.3 15.3l2.4 2.4M17.7 6.3l-2.4 2.4M8.7 15.3l-2.4 2.4" />
            </svg>
            Generate
          </button>
        )}
        <button type="button" className={btn} onClick={onAssign} title="Assign this section">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <line x1="19" y1="8" x2="19" y2="14" />
            <line x1="22" y1="11" x2="16" y2="11" />
          </svg>
          Assign
        </button>
        <span className="w-px h-4 bg-[#ECE9EE] mx-0.5" />
        <button
          type="button"
          onClick={onMarkDone}
          disabled={isDone}
          title={isDone ? "Already marked done" : "Mark this section done"}
          className={`${btn} ${isDone ? "text-[#2DAD4E]" : ""}`}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          {isDone ? "Done" : "Mark done"}
        </button>
      </div>
    );
  };

  // A node in the group that isn't the one being edited. Only one node is live
  // at a time (a single editor instance owns save/undo), so these render as
  // HTML — but clicking one hands it the editor, which is what makes the whole
  // group feel editable instead of half-inert.
  const StaticNode = ({ node, indexInDoc, onSelect, actions }) => (
    <section
      onMouseDown={onSelect ? (e) => onSelect(node.id, e) : undefined}
      className={`relative ${groupRule(node.depth, indexInDoc)} ${
        node.depth === 1 ? "proposal-node-sub" : ""
      } ${onSelect ? "cursor-text group/node hover:bg-[#FAF7FA] transition-colors" : ""}`}
    >
      {actions}
      <NodeHeading nodeId={node.id} number={node.number} title={node.title} depth={node.depth} />
      <div
        className="ProseMirror"
        dangerouslySetInnerHTML={{ __html: stripBlockGaps(node.content) || "<p></p>" }}
      />
    </section>
  );

  const ProposalEditor = forwardRef(
    ({ initialContent, onChange, onReady, folderId, onReachBoundary, scrollToEnd = false, title, number, depth = 0, precedingNodes = [], followingNodes = [], nodeId, scrollToNodeId, onVisibleNodeChange, onSelectNode, viewCarry, nodeActionsFor, activeNodeActions }, ref) => {
      // Resume/PDF insertion progress (shared with the toolbar + slash menu).
      const [resumeProgress, setResumeProgress] = useState(null);
      // Shown while a pasted/dropped image is uploading.
      const [imgUploading, setImgUploading] = useState(false);
      // Slash ("/") menu: null when closed, else { query, range, coords }.
      const [slash, setSlash] = useState(null);
      const [slashIndex, setSlashIndex] = useState(0);

      const slashItems = useMemo(() => filterSlashCommands(slash?.query), [slash]);

      // Mirror the live menu state into refs so the ProseMirror keydown handler
      // (created once, below) can always read the current items/index/range.
      const slashRef = useRef({ active: false, items: [], index: 0, range: null });
      const runSlashRef = useRef(() => {});
      const contentScrollRef = useRef(null);
      const boundaryReachedRef = useRef(false);
      const visibleNodeRef = useRef(null);

      // Handing the editor to a sibling remounts this component (its key is the
      // active node id), which would replay the enter animation and reset the
      // scroll. Clicking a node you can already see should just put a caret in
      // it, so we carry the scroll position across that remount in a ref owned
      // by the PARENT (ours would die with the unmount) and skip the animation.
      // Captured (not just flagged) at mount: re-reading the ref in the effect
      // would break under StrictMode's double-invoke, where the first pass has
      // already cleared it and the second would scroll to 0.
      const [mountCarry] = useState(() => viewCarry?.current || null);

      // True when the editor is showing a section group (siblings alongside the
      // live node) rather than a single standalone node.
      const isGroupView = precedingNodes.length > 0 || followingNodes.length > 0;
      // A section with no subsections is alone in the pane, so isGroupView is
      // false — but it is still a section, and it still needs Generate / Assign /
      // Mark done. isGroupView answers "is there anything to scroll past", not
      // "is there anything to act on", and conflating the two left those sections
      // with no hover toolbar at all.
      //
      // With one node in the pane, the scroll container IS the hover target.
      // Gated rather than always-on because every StaticNode carries its own
      // group/node — unconditionally, hovering anywhere would light up all of
      // them at once. The analysis page passes no actions and is unaffected.
      const isSoloNode = !isGroupView && !!activeNodeActions;

      // Fired on mousedown so the caret point is captured before the click
      // completes. Carrying the coordinates lets the newly-mounted editor drop
      // the cursor exactly where the user pressed — otherwise the first click
      // only swaps the editor in and a second one is needed to place the caret.
      const selectStaticNode = (id, event) => {
        if (viewCarry) {
          viewCarry.current = {
            scrollTop: contentScrollRef.current?.scrollTop || 0,
            caret: event ? { left: event.clientX, top: event.clientY } : null,
          };
        }
        onSelectNode?.(id);
      };

      const handleContentScroll = (event) => {
        // Optional callback — skip the DOM sweep entirely when nobody listens.
        if (!onVisibleNodeChange) return;
        const container = event.currentTarget;
        const headers = container.querySelectorAll("[data-proposal-node-id]");
        const containerTop = container.getBoundingClientRect().top;
        let visible = headers[0];
        headers.forEach((header) => {
          if (header.getBoundingClientRect().top - containerTop <= 80) visible = header;
        });
        const id = visible?.dataset.proposalNodeId;
        if (id && id !== visibleNodeRef.current) {
          visibleNodeRef.current = id;
          onVisibleNodeChange?.(id);
        }
      };

      useEffect(() => {
        const el = contentScrollRef.current;
        if (!el) return;
        // Restore the exact position from before a click-to-edit switch, so the
        // page doesn't scroll the clicked node up to the top under the cursor.
        if (mountCarry) {
          if (viewCarry) viewCarry.current = null;   // idempotent: value lives in state
          requestAnimationFrame(() => {
            el.scrollTop = mountCarry.scrollTop;
          });
          return;
        }
        requestAnimationFrame(() => {
          const target = Array.from(el.querySelectorAll("[data-proposal-node-id]")).find(
            (header) => header.dataset.proposalNodeId === String(scrollToNodeId)
          );
          if (!target) {
            el.scrollTop = scrollToEnd ? el.scrollHeight : 0;
            return;
          }
          // Measured with rects rather than offsetTop: offsetTop is relative to
          // the nearest POSITIONED ancestor, so it silently breaks the moment a
          // node wrapper becomes `relative` (which the hover toolbar needs).
          // Rect deltas don't care about the positioning context.
          //
          // Stop NODE_TOP_GUTTER short of flush so the node's hover toolbar —
          // which floats above its top edge — isn't clipped by the container.
          el.scrollTop +=
            target.getBoundingClientRect().top -
            el.getBoundingClientRect().top -
            NODE_TOP_GUTTER;
        });
        // mountCarry is set once at mount and viewCarry is a ref, so neither adds
        // a re-run — they're listed to keep the dependency check honest.
      }, [scrollToEnd, scrollToNodeId, mountCarry, viewCarry]);

      const handleContentWheel = (event) => {
        const el = contentScrollRef.current;
        if (!el || boundaryReachedRef.current) return;
        const atTop = el.scrollTop <= 0;
        const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
        const direction = event.deltaY < 0 && atTop ? "previous" : event.deltaY > 0 && atBottom ? "next" : null;
        if (!direction) return;
        boundaryReachedRef.current = true;
        onReachBoundary?.(direction);
      };

      // Upload an image file and insert it at a doc position (or the current
      // selection when pos is null). Backs the paste + drag-drop handlers.
      const uploadInsertImageAt = async (file, pos) => {
        if (!folderId) return; // real upload needs a folder to scope against
        try {
          setImgUploading(true);
          const url = await uploadEditorImage(file, folderId, file.name || "image.png");
          if (pos == null) {
            editor?.chain().focus().setImage({ src: url }).run();
          } else {
            editor
              ?.chain()
              .focus()
              .insertContentAt(pos, { type: "image", attrs: { src: url } })
              .run();
          }
        } catch (err) {
          console.error("Image upload failed", err);
          window.alert(
            "Could not upload image: " +
              (err?.response?.data?.error || err?.message || "unknown error")
          );
        } finally {
          setImgUploading(false);
        }
      };

      const editor = useEditor({
        extensions: [
          StarterKit.configure({
            heading: { levels: [1, 2, 3, 4, 5, 6] },
          }),
          Underline,
          TextStyle,
          Color,
          Image.configure({ inline: false, allowBase64: true }),
          Link.configure({ openOnClick: false, autolink: true }),
          TextAlign.configure({ types: ["heading", "paragraph"] }),
          Table.configure({ resizable: true }),
          TableRow,
          TableHeader,
          TableCell,
          Placeholder.configure({
            placeholder: "Start editing your proposal...",
          }),
        ],
        content: initialContent || "",
        onUpdate: ({ editor: e }) => {
          onChange?.(e.getHTML());
        },
        editorProps: {
          // Route arrow/enter/escape to the slash menu while it's open.
          handleKeyDown: (view, event) => {
            const s = slashRef.current;
            if (!s.active || !s.items.length) return false;
            if (event.key === "ArrowDown") {
              setSlashIndex((i) => (i + 1) % s.items.length);
              return true;
            }
            if (event.key === "ArrowUp") {
              setSlashIndex((i) => (i - 1 + s.items.length) % s.items.length);
              return true;
            }
            if (event.key === "Enter" || event.key === "Tab") {
              runSlashRef.current(s.items[s.index]);
              return true;
            }
            if (event.key === "Escape") {
              setSlash(null);
              return true;
            }
            return false;
          },
          // Paste an image straight from the clipboard (e.g. a screenshot).
          handlePaste: (view, event) => {
            if (!folderId) return false;
            const items = event.clipboardData?.items;
            if (!items) return false;
            for (const it of items) {
              if (it.type && it.type.startsWith("image/")) {
                const file = it.getAsFile();
                if (file) {
                  event.preventDefault();
                  uploadInsertImageAt(file, null);
                  return true;
                }
              }
            }
            return false;
          },
          // Drag an image file in from the desktop.
          handleDrop: (view, event, slice, moved) => {
            if (moved || !folderId) return false;
            const files = event.dataTransfer?.files;
            if (!files || !files.length) return false;
            const imgs = Array.from(files).filter(
              (f) => f.type && f.type.startsWith("image/")
            );
            if (!imgs.length) return false;
            event.preventDefault();
            const coords = view.posAtCoords({
              left: event.clientX,
              top: event.clientY,
            });
            const basePos = coords ? coords.pos : view.state.selection.from;
            imgs.forEach((file) => uploadInsertImageAt(file, basePos));
            return true;
          },
        },
      });
  
      // Notify parent once the editor is ready so it can capture the
      // initial normalized content for dirty-checking.
      useEffect(() => {
        if (editor && onReady) onReady(editor);
      }, [editor, onReady]);

      // Place the caret where the user clicked on a node that wasn't yet live.
      // Keyed on `editor` because useEditor returns null on the first render —
      // doing this in the scroll effect above would run before the instance
      // exists and silently drop the caret. The rAF lands after the scroll
      // restore queued there, so the stored viewport coordinates still line up.
      const pendingCaretRef = useRef(mountCarry?.caret || null);
      useEffect(() => {
        const caret = pendingCaretRef.current;
        if (!editor || !caret) return;
        pendingCaretRef.current = null;
        requestAnimationFrame(() => {
          try {
            const at = editor.view.posAtCoords({ left: caret.left, top: caret.top });
            // posAtCoords misses when the press landed outside the editable area
            // (a heading, the padding) — focusing without a position is right there.
            if (at) editor.commands.focus(at.pos);
            else editor.commands.focus();
          } catch (err) {
            editor.commands.focus();
          }
        });
      }, [editor]);
  
      // Imperative API for the parent
      useImperativeHandle(
        ref,
        () => ({
          getContent: () => editor?.getHTML() ?? "",
          setContent: (html) => {
            if (!editor) return;
            editor.commands.setContent(html || "", false);
          },
          clearHistory: () => {
            // Tiptap doesn't expose undoManager.clear() directly; resetting
            // content with the second arg false skips history, but to truly
            // wipe history we re-create the doc state.
            if (!editor) return;
            const html = editor.getHTML();
            editor.commands.setContent(html, false);
          },
          focus: () => editor?.commands.focus(),
          editor,
        }),
        [editor]
      );
  
      // Keep the keydown handler's view of the menu current.
      useEffect(() => {
        slashRef.current = {
          active: !!slash && slashItems.length > 0,
          items: slashItems,
          index: slashIndex,
          range: slash?.range || null,
        };
      }, [slash, slashItems, slashIndex]);

      // Execute a slash command: remove the "/query" text, then run the action.
      const runSlashItem = useCallback(
        (item) => {
          if (!item || !editor) return;
          const range = slashRef.current.range;
          if (range) editor.chain().focus().deleteRange(range).run();
          item.run(editor, { folderId, setResumeProgress, setImgUploading });
          setSlash(null);
        },
        [editor, folderId]
      );
      runSlashRef.current = runSlashItem;

      // Detect "/" typing at the cursor and open/close the menu accordingly.
      useEffect(() => {
        if (!editor) return undefined;
        const update = () => {
          const ctx = getSlashContext(editor);
          if (!ctx) {
            setSlash((prev) => (prev ? null : prev));
            return;
          }
          let coords = null;
          try {
            coords = editor.view.coordsAtPos(ctx.range.to);
          } catch (e) {
            coords = null;
          }
          setSlash({ ...ctx, coords });
          setSlashIndex(0);
        };
        editor.on("update", update);
        editor.on("selectionUpdate", update);
        return () => {
          editor.off("update", update);
          editor.off("selectionUpdate", update);
        };
      }, [editor]);

      return (
        <div
          className={`proposal-editor h-full flex flex-col ${isGroupView ? "proposal-continuous" : ""}`}
          style={
            mountCarry
              ? undefined   // click-to-edit: stay put, no slide-in
              : { animation: `proposal-editor-enter-${scrollToEnd ? "up" : "down"} 140ms ease-out both` }
          }
        >
          <style>{EDITOR_STYLES}</style>
          <Toolbar
            editor={editor}
            folderId={folderId}
            resumeProgress={resumeProgress}
            setResumeProgress={setResumeProgress}
          />
          {/* pt-4 reserves the strip the hover toolbar floats into. The toolbar
              sits at -top-2 on its node, so on the FIRST node that lands above
              the scroll container — where overflow-y clips it against the
              formatting bar. The padding gives it somewhere to live. */}
          <div
            ref={contentScrollRef}
            onScroll={handleContentScroll}
            onWheel={handleContentWheel}
            className={`flex-1 overflow-y-auto custom-scrollbar relative pt-4 ${isSoloNode ? "group/node" : ""}`}
          >
            {precedingNodes.map((node, i) => (
              <StaticNode
                key={node.id}
                node={node}
                indexInDoc={i}
                onSelect={onSelectNode ? selectStaticNode : undefined}
                actions={nodeActionsFor?.(node)}
              />
            ))}
            {/* The active node — same heading treatment as the static ones, but
                its body is the live editor rather than rendered HTML.

                Marked with an inset accent bar rather than a border or an
                absolutely-positioned rail: a border would shift the text by its
                width, and `position: relative` here would make the heading's
                offsetParent this wrapper instead of the scroll container, which
                is what scroll-to-node measures with offsetTop. */}
            {isGroupView ? (
              // No selection rail: which node you're in is shown by the caret and
              // by its hover toolbar, so a permanent accent stripe was one signal
              // too many — and it implied "selected" mattered when what actually
              // matters is where you're typing.
              <div className={`relative group/node ${groupRule(depth, precedingNodes.length)}`}>
                {activeNodeActions}
                <NodeHeading nodeId={nodeId} number={number} title={title} depth={depth} />
                <EditorContent editor={editor} className={depth === 1 ? "proposal-node-sub" : ""} />
              </div>
            ) : (
              // Lone node — a section with no subsections, or the analysis page.
              // Nothing to distinguish it from, and the editor must fill the pane
              // so clicking anywhere below the text still places a caret — hence
              // no wrapper, which would break `h-full`.
              //
              // The toolbar therefore hangs off a zero-height anchor instead. It
              // needs a positioning ancestor that starts BELOW the container's
              // pt-4: measured against the container itself, -top-2 lands above
              // the padding box and overflow-y clips it away.
              <>
                {isSoloNode && <div className="relative h-0">{activeNodeActions}</div>}
                <NodeHeading nodeId={nodeId} number={number} title={title} depth={depth} />
                <EditorContent editor={editor} className="h-full" />
              </>
            )}
            {followingNodes.map((node, i) => (
              <StaticNode
                key={node.id}
                node={node}
                indexInDoc={precedingNodes.length + 1 + i}
                onSelect={onSelectNode ? selectStaticNode : undefined}
                actions={nodeActionsFor?.(node)}
              />
            ))}
            {imgUploading && (
              <div className="absolute bottom-3 right-3 z-20 flex items-center gap-2 rounded-md bg-white/95 border border-gray-200 shadow-sm px-3 py-1.5 text-xs font-outfit text-[#A04A97]">
                <Loader2 size={14} className="animate-spin" />
                Uploading image…
              </div>
            )}
          </div>
          <SlashMenu
            slash={slash}
            items={slashItems}
            activeIndex={slashIndex}
            onPick={runSlashItem}
          />
        </div>
      );
    }
  );
  
  ProposalEditor.displayName = "ProposalEditor";
  
  export default ProposalEditor;
